module.exports = __webpack_public_path__ + "img/joinUs_channel1.d3559a9d.png";